import { render, staticRenderFns } from "./ReadonlyViewPlanParts.vue?vue&type=template&id=3e780b61&scoped=true"
import script from "./ReadonlyViewPlanParts.vue?vue&type=script&lang=js"
export * from "./ReadonlyViewPlanParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e780b61",
  null
  
)

export default component.exports